// @ts-strict-ignore
import React from 'react'
import { connect } from 'react-redux'
import { FsCore } from '../../../types/fs-core'
import Image from '../../imgix-img'
import { Icon, Slider } from '../../../atoms'
import { brand, trustpilot } from '../../../redux/app-selectors'

interface TrustPilotReviewsProps {
  trustpilotData: {
    companyScore: {
      score: {
        trustScore: number
        stars: string
      }
      totalReviews: number
    }
    reviews: {
      title: string
      stars: string
      text: string
      customer: {
        name: string
        location: string | null
      }
    }[]
  }
  name: string
  rawName: string
  variant: string
  sys: {
    id: string
  }
  brand: 'money' | 'uswitch'
}
const truncateString = (str: string) => {
  if (str.length <= 500) {
    return str
  }
  return str.slice(0, 500) + '...'
}

const TrustPilotReviews: React.FC<TrustPilotReviewsProps> = ({
  trustpilotData,
  name,
  rawName,
  variant,
  sys,
  brand,
}) => {
  try {
    return trustpilotData ? (
      <div className='TrustPilotReviews' id={name}>
        <div className='TrustPilotReviews__score'>
          <h2 className='TrustPilotReviews__score__title'>Customer Reviews</h2>
          <a
            className='TrustPilotReviews__score__logo'
            target='_blank'
            href={trustpilotData.link}
            rel='noreferrer'
          >
            {/* @ts-ignore */}
            <Icon
              glyph={'trust-pilot-logo-white'}
              color={brand === 'money' ? '#fff' : '#000000'}
              fill={brand === 'money' ? '#fff' : '#000000'}
            />
            <Image
              src={`https://images-static.trustpilot.com/api/stars/${trustpilotData.companyScore.score.stars}/128x24.png`}
              alt={'Trust Pilot stars'}
            />
          </a>
          <div className='TrustPilotReviews__score__rating'>
            Rated {trustpilotData.companyScore.score.trustScore} out of 5
          </div>
          <div className='TrustPilotReviews__score__people'>
            by {trustpilotData.companyScore.totalReviews} people
          </div>
        </div>

        <section className='TrustPilotReviews__Carousel' data-controller='platinum-carousel'>
          <div className='TrustPilotReviews__Carousel__leftArrow' data-action='leftArrowClick'>
            <Icon glyph={'arrow-left-trust'} size={45} />
          </div>
          <div className='TrustPilotReviews__Carousel__rightArrow' data-action='rightArrowClick'>
            <Icon glyph={'arrow-right-trust'} size={45} />
          </div>
          <div
            className='TrustPilotReviews__Carousel__Cards'
            data-platinum-carousel-target='carouselContainer'
          >
            {trustpilotData.reviews.map((review, index) => {
              return (
                <div
                  key={index}
                  className='TrustPilotReviews__Carousel__Card'
                  data-platinum-carousel-target='carouselCard'
                  /* eslint-disable camelcase */
                  data-scroll-tracking={JSON.stringify({
                    component_category: 'platinum-component',
                    component_id: sys?.id,
                    component_name: 'trustpilot',
                    contentful_name: rawName,
                    contentful_variant: variant,
                    additionalProps: { title: review.title },
                  })}
                >
                  <div className='TrustPilotReviews__Carousel__Card__header'>
                    <blockquote className='TrustPilotReviews__Carousel__Card__header--title'>
                      {review.title}
                    </blockquote>
                    <div className='TrustPilotReviews__Carousel__Card__header--stars'>
                      <Image
                        src={`https://images-static.trustpilot.com/api/stars/${review.stars}/128x24.png`}
                        alt={'Trust Pilot stars'}
                      />
                    </div>
                  </div>
                  <div className='TrustPilotReviews__Carousel__Card__body'>
                    {truncateString(review.text)}
                  </div>
                  <div className='TrustPilotReviews__Carousel__Card__customer'>
                    <div>{review.customer.name}</div>
                    {review.customer.location && <div>{review.customer.location}</div>}
                  </div>
                </div>
              )
            })}
          </div>
          <Slider
            cards={trustpilotData.reviews}
            variant={brand === 'money' ? 'white' : 'primary'}
          />
        </section>
      </div>
    ) : (
      <></>
    )
  } catch (error) {
    return <></>
  }
}

export default connect((state: FsCore.State, props: any) => {
  const { name, rawName, variant, jsonBody } = props
  const tpBrand = jsonBody.brand || brand(state)

  return {
    trustpilotData: trustpilot(state, tpBrand),
    name,
    rawName,
    variant,
    brand: brand(state),
  }
})(TrustPilotReviews)
